import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Input } from 'reactstrap';
import { Field } from './Field';
import Combobox from './Combobox';
import { TimeFrame, getTimeFrameName, TimeFrameIsSelectable } from '../../../../utils/Order/Order';

const TimeForce = ({onChange, timeForce, date, errors, readonly}) => {

  /*
    TimeForce = OPG se utiliza si solo si el type es Market Open. 
    Si el type != Market Open, se puede seleccionar cualquier TimeForce, excepto OPG.
  */
  const typeItems = timeForce == 'OPG' ? 
  [{id: 'OPG', description: 'OPG'}]
  :
  Object.values(TimeFrame).filter(k => TimeFrameIsSelectable(k)).map((key, index) => (
    { id: key, description: getTimeFrameName(key) }
  ))

  return (
    <div>
      <Row>
        <Col lg={6}>
          <Field label={'Time in force'} error={errors.timeForce}>
            <Combobox 
              value={timeForce}
              items={typeItems}
              disabled={readonly.timeForce}
              onChange={(v) => onChange({'OrderTimeInForce': v})}
              placeholder={'Time in force'}
              style={{background: '#edf9ff', fontWeight: 500}}
            />
          </Field>
        </Col>
        <Col lg={6}>
          { timeForce == TimeFrame.GTD &&
            <Field label={'Date'} error={errors.date}>
              <Input type={'date'} 
                placeholder={'Date'} 
                onChange={(e) => onChange({'OrderGTD': e.target.value})} 
                value={date}
                disabled={readonly.date}
                style={{padding: '6px 4px'}}
                required
              />
            </Field>
          }
        </Col>
      </Row>
    </div>
  )
}

export default React.memo(TimeForce);